import { useSelector } from "react-redux";
import { selectToolName } from "../slices/footer/footerSlice";
import toolVersions from "../dictionaries/AppToolVersions";

const Footer = () => {

    const toolName = useSelector(state => selectToolName(state));

    return <footer>
        {toolName ?
            <div style={{ wordBreak: "break-word" }}>
                <a style={{ alignSelf: "flex-end" }} href="https://computablepublishing.com"
                    target="_blank" rel="noopener noreferrer">
                    <img style={{ height: "28px" }}
                        alt="Computable Publishing logo and hyperlink to site"
                        src="/png-01-wide-tinnier.png" />
                </a> {/**TODO -- the textWrap feature was not recognized below, in style or directly in span is not resulting in wrapping in the footer
                 * and wordBreak in span style or higher div style is not working either
                 */}
                <span className="pagecontent" style={{ width: "100%", wordBreak: "break-word", 
                    fontSize: "14px", paddingLeft: "14px", alignSelf: "flex-end" }}  >
                    &#169; 2021-2025 Computable Publishing LLC, Patent Pending. FEvIR<sup style={{ fontSize: "xx-small" }}>®</sup> Platform {toolVersions.platform} uses <a
                        href="https://build.fhir.org" target="_blank" rel="noopener noreferrer">
                        FHIR<sup style={{ fontSize: "xx-small" }}>®</sup> current build
                    </a>.
                    {toolName === "FevirSearch" && <> Placeholder. </>}
                    &#169; Use implies agreement to the <a href="https://fevir.net/termsofuse"
                        target="_blank" rel="noopener noreferrer">Acceptable Use Policy
                    </a>. <a href="mailto:support@computablepublishing.com">support@computablepublishing.com</a>
                </span>
            </div>
            :
            <div className="footer-text">&#169; 2025 Computable Publishing LLC</div>
        }
    </footer>
}

export default Footer;